import { Blacklist } from "./blacklist";
import { Organization } from "./organization";
import { Project } from "./project";
import { Register } from "./register";

export enum AccountType {
  Root = 1,
  Manager = 2,
  Normal = 3,
}

export interface UserInfo {
  id: number;
  account?: string;
  phone?: string;
  type: AccountType;
  isPasswordInited: boolean;
  adminOrganizations: Organization[];
  reviewerOrganizations: Organization[];
  adminProjects: Project[];
}

export type LoginParams = {
  account: string;
} & (
  | {
      password: string;
    }
  | {
      captcha: string;
    }
);

export interface SignupParams {
  phone: string;
  password: string;
  captcha: string;
}

export interface ResetPasswordParams {
  phone: string;
  password: string;
  captcha: string;
}

export interface AnalyseUserInfo extends UserInfo {
  id: number;
  account?: string;
  phone?: string;
  type: AccountType;
  isPasswordInited: boolean;
  isProjectAdmin: boolean;
  isOrganizationAdmin: boolean;
  isOrganizationReviewer: boolean;
  registerPlayerSuccessCount: number;
  registerUnitSuccessCount: number;
  joinedTeamCount: number;
  registers: Register[];
  blacklist?: Blacklist;
}
